import React, { useContext } from 'react';
import { CollapsibleContext } from './CollapsibleAdvanced';
function CollapsibleVisible(_ref) {
  let {
    children,
    whenOpen: visibleWhenOpen,
    whenClosed: visibleWhenClosed
  } = _ref;
  const {
    isOpen
  } = useContext(CollapsibleContext);
  const isVisible = isOpen && visibleWhenOpen || !isOpen && visibleWhenClosed;
  if (isVisible) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return null;
}
CollapsibleVisible.defaultProps = {
  children: undefined,
  whenOpen: false,
  whenClosed: false
};
export default CollapsibleVisible;